import MainLayout from "@/components/layout/MainLayout";

const Privacy = () => {
  return (
    <MainLayout>
      <div className="container-page max-w-4xl mx-auto">
        <h1 className="text-2xl font-bold mb-6">Политика конфиденциальности</h1>
        
        <div className="bg-card rounded-lg border p-6 shadow-sm">
          <div className="prose prose-gray max-w-none">
            <p className="text-sm text-muted-foreground mb-6">
              Последнее обновление: {new Date().toLocaleDateString('ru-RU')}
            </p>
            
            <h2>1. Введение</h2>
            <p>
              Voice2Doc уважает вашу конфиденциальность и стремится защищать ваши персональные данные. 
              Настоящая Политика конфиденциальности объясняет, как мы собираем, используем, раскрываем, 
              обрабатываем и защищаем информацию, которую вы предоставляете при использовании нашего сервиса.
            </p>
            
            <h2>2. Какую информацию мы собираем</h2>
            <p>
              Мы собираем следующие типы информации:
            </p>
            <ul>
              <li>
                <strong>Информация учетной записи:</strong> имя, адрес электронной почты, пароль (в зашифрованном виде) 
                и другие данные, которые вы предоставляете при регистрации.
              </li>
              <li>
                <strong>Информация о платежах:</strong> данные платежных карт, история транзакций и информация о выставленных счетах.
              </li>
              <li>
                <strong>Загружаемые файлы:</strong> аудио и видео файлы, которые вы загружаете для обработки.
              </li>
              <li>
                <strong>Созданный контент:</strong> транскрипции, обработанные тексты и документы, созданные на основе ваших файлов.
              </li>
              <li>
                <strong>Технические данные:</strong> IP-адрес, тип устройства, тип и версия браузера, операционная система, 
                данные о посещениях и использовании сервиса.
              </li>
            </ul>
            
            <h2>3. Как мы используем вашу информацию</h2>
            <p>
              Мы используем собранную информацию для следующих целей:
            </p>
            <ul>
              <li>Предоставление и поддержка наших услуг</li>
              <li>Обработка платежей и управление вашим аккаунтом</li>
              <li>Улучшение и персонализация пользовательского опыта</li>
              <li>Отправка уведомлений о состоянии обработки файлов</li>
              <li>Обеспечение безопасности и предотвращение мошенничества</li>
              <li>Соблюдение юридических обязательств</li>
            </ul>
            
            <h2>4. Хранение и защита данных</h2>
            <p>
              Мы принимаем технические, административные и физические меры для защиты ваших данных от 
              несанкционированного доступа, использования или раскрытия. Все данные передаются с использованием 
              шифрования SSL/TLS и хранятся на защищенных серверах.
            </p>
            <p>
              Ваши файлы и созданные документы хранятся в течение периода, необходимого для предоставления услуг, 
              или до тех пор, пока вы не удалите их из своего аккаунта.
            </p>
            
            <h2>5. Передача данных третьим лицам</h2>
            <p>
              Мы не продаем ваши персональные данные третьим лицам. Мы можем передавать данные следующим категориям получателей:
            </p>
            <ul>
              <li>
                <strong>Поставщики услуг:</strong> компании, которые помогают нам предоставлять услуги 
                (обработка платежей, хостинг, аналитика).
              </li>
              <li>
                <strong>Партнеры по AI:</strong> для обработки аудио и видео файлов с использованием технологий 
                искусственного интеллекта.
              </li>
              <li>
                <strong>Правоохранительные органы:</strong> когда это требуется по закону или для защиты наших прав.
              </li>
            </ul>
            <p>
              Все третьи стороны, с которыми мы делимся данными, обязаны обеспечивать соответствующий уровень защиты 
              ваших персональных данных.
            </p>
            
            <h2>6. Ваши права</h2>
            <p>
              В зависимости от вашего местоположения, вы можете иметь следующие права в отношении ваших данных:
            </p>
            <ul>
              <li>Право на доступ к вашим персональным данным</li>
              <li>Право на исправление неточных данных</li>
              <li>Право на удаление ваших данных</li>
              <li>Право на ограничение обработки</li>
              <li>Право на перенос данных</li>
              <li>Право на возражение против обработки</li>
            </ul>
            <p>
              Для реализации этих прав, пожалуйста, свяжитесь с нами по адресу: privacy@voice2doc.ru
            </p>
            
            <h2>7. Файлы cookie и аналогичные технологии</h2>
            <p>
              Мы используем файлы cookie и аналогичные технологии для улучшения работы сервиса, анализа 
              использования и персонализации вашего опыта. Вы можете управлять настройками файлов cookie 
              через настройки вашего браузера.
            </p>
            
            <h2>8. Дети</h2>
            <p>
              Наш сервис не предназначен для детей младше 16 лет. Мы сознательно не собираем персональные 
              данные от детей младше 16 лет. Если вы узнали, что ребенок предоставил нам персональные данные, 
              пожалуйста, свяжитесь с нами.
            </p>
            
            <h2>9. Изменения в политике конфиденциальности</h2>
            <p>
              Мы можем обновлять нашу Политику конфиденциальности время от времени. Мы уведомим вас о любых 
              существенных изменениях путем размещения новой версии на нашем сайте или отправки уведомления.
            </p>
            
            <h2>10. Контактная информация</h2>
            <p>
              Если у вас есть вопросы или предложения относительно нашей Политики конфиденциальности, 
              пожалуйста, свяжитесь с нами по адресу: privacy@voice2doc.ru
            </p>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default Privacy;